import { HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING } from './constant'
import { getPdfHeightImage } from './helper'

class PdfData {
  pdfData = []
  page = 1
  availableHeightPage = 800
  currentPageData = { page: 1, items: [] }

  addNewPage = () => {
    this.pdfData.push(this.currentPageData)
    this.page += 1
    this.availableHeightPage = HEIGHT_PDF_PORTRAIT_WITHOUT_PADDING
    this.currentPageData = { page: this.page, items: [] }
  }

  addContent = (item) => {
    if (item.img) {
      item.img.forEach(({ data, width, height }) => {
        let heightContent = getPdfHeightImage(width, height)
        if (this.availableHeightPage < heightContent) {
          this.addNewPage()
        }
        this.currentPageData.items.push({
          img: data,
        })
        this.availableHeightPage -= heightContent
      })
    }
  }

  getData = () => {
    this.pdfData.push(this.currentPageData)
    return this.pdfData
  }

  getAvailableHeightPage = () => {
    return this.availableHeightPage
  }
}

export default PdfData
